export const useSingleParam = (param?: string | string[]) => {
  return typeof param === 'string'
    ? param
    : Array.isArray(param)
    ? param[0]
    : undefined;
};
